import { render, staticRenderFns } from "./ordersDeliveryPrintPaymentSummaryTable.vue?vue&type=template&id=5d2cb8a7&"
import script from "./ordersDeliveryPrintPaymentSummaryTable.vue?vue&type=script&lang=ts&"
export * from "./ordersDeliveryPrintPaymentSummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports